module.exports = __webpack_public_path__ + "img/BJ.dd956c2b.png";